import React from "react";

const Pill: React.FC<{ text: string; styling: string; small?: boolean }> = ({
  text,
  styling,
  small = false,
}) => {
  return (
    <span
      className={`${
        small ? "text-[0.65rem]" : "text-xs"
      } px-4 py-0.5 cursor-pointer rounded-full border whitespace-nowrap font-medium max-w-48 2xl:max-w-56 overflow-hidden text-ellipsis ${styling}`}
    >
      <span
        className="overflow-hidden text-ellipsis whitespace-nowrap"
        title={text}
      >
        {text}
      </span>
    </span>
  );
};

export default Pill;
